// Story 16.5/16.6 — los links de invitación y de reset llevan el token en el
// fragmento (`/invite#<token>`), que el navegador nunca manda al servidor. Al
// abrir la página se guarda en sessionStorage y se borra de la barra: sobrevive
// a un reload o al paso por el login sin aparecer en ninguna URL.

export function readHashToken(storageKey: string): string | null {
  const fromHash = window.location.hash.replace(/^#/, '');
  try {
    if (fromHash) {
      sessionStorage.setItem(storageKey, fromHash);
      window.history.replaceState(null, '', window.location.pathname);
      return fromHash;
    }
    return sessionStorage.getItem(storageKey);
  } catch {
    return fromHash || null;
  }
}

export function forgetHashToken(storageKey: string): void {
  try {
    sessionStorage.removeItem(storageKey);
  } catch {
    // Sin storage no hay nada que borrar.
  }
}
